




























































































































import { Component, Vue } from "vue-property-decorator";
import CustomFieldCreator from "@/components/CustomFieldCreator.vue";
import { contextModule } from "@/store/context";
import Axios from "axios";
import { serverBase } from "@/apollo";

@Component({
  components: {
    CustomFieldCreator,
  },
})
export default class About extends Vue {
  version = "";

  set experimental(val: boolean) {
    if (val) {
      localStorage.setItem("pm_experimental", "true");
    } else {
      localStorage.removeItem("pm_experimental");
    }
    contextModule.toggleExperimental(val);
  }

  get experimental() {
    return contextModule.experimental;
  }

  mounted() {
    Axios.get(`${serverBase}/version?password=${localStorage.getItem("password")}`)
      .then(({ data }) => {
        this.version = data.result;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  set fillActorCards(val: boolean) {
    localStorage.setItem("pm_fillActorCards", val.toString());
    contextModule.toggleActorCardStyle(val);
  }

  get fillActorCards() {
    return contextModule.fillActorCards;
  }

  set showCardLabels(val: boolean) {
    localStorage.setItem("pm_showCardLabels", val.toString());
    contextModule.toggleCardLabels(val);
  }

  get showCardLabels() {
    return contextModule.showCardLabels;
  }

  set actorRatio(val: number) {
    localStorage.setItem("pm_actorRatio", val.toString());
    contextModule.setActorAspectRatio(val);
  }

  get actorRatio() {
    return contextModule.actorAspectRatio;
  }

  set sceneRatio(val: number) {
    localStorage.setItem("pm_sceneRatio", val.toString());
    contextModule.setSceneAspectRatio(val);
  }

  get sceneRatio() {
    return contextModule.sceneAspectRatio;
  }

  set scenePauseOnUnfocus(val: boolean) {
    localStorage.setItem("pm_scenePauseOnUnfocus", val.toString());
    contextModule.setScenePauseOnUnfocus(val);
  }

  get scenePauseOnUnfocus() {
    return contextModule.scenePauseOnUnfocus;
  }

  set scenePreviewOnMouseHover(val: boolean) {
    localStorage.setItem("pm_scenePreviewOnMouseHover", val.toString());
    contextModule.setScenePreviewOnMouseHover(val);
  }

  get scenePreviewOnMouseHover() {
    return contextModule.scenePreviewOnMouseHover;
  }

  toggleDarkMode() {
    // @ts-ignore
    this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    localStorage.setItem(
      "pm_darkMode",
      // @ts-ignore
      this.$vuetify.theme.dark ? "true" : "false"
    );
  }
}
